import component from "./WithOnSearch";
export default [{ component }];